var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIcon9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.233,
    height: 22.675,
    viewBox: "0 0 20.233 22.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12497",
    "data-name": "Group 12497",
    transform: "translate(-46.946 -678.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38502",
    "data-name": "Path 38502",
    d: "M50.724,693.688V679.325H65.155v17.149",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38503",
    "data-name": "Path 38503",
    d: "M52.692,686.556a10.818,10.818,0,0,0,2.287.343c1,0,2-.64,2-1.429s-1.4-1.287-2-1.43-2-.64-2-1.429,1-1.43,2-1.43a15.906,15.906,0,0,1,2.288.228",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    x2: 0.028,
    y2: 7.806,
    transform: "translate(54.979 680.266)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x2: 5.304,
    transform: "translate(58.32 680.834)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    x2: 5.304,
    transform: "translate(58.32 682.933)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    x2: 5.304,
    transform: "translate(58.32 685.032)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_336",
    "data-name": "Line 336",
    x2: 5.304,
    transform: "translate(58.32 687.131)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_337",
    "data-name": "Line 337",
    x2: 11.178,
    transform: "translate(52.446 689.834)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_338",
    "data-name": "Line 338",
    x2: 11.178,
    transform: "translate(52.446 691.933)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5520",
    "data-name": "Rectangle 5520",
    width: 3.83,
    height: 6.964,
    transform: "translate(47.446 693.688)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38504",
    "data-name": "Path 38504",
    d: "M51.624,694.733h3.455a7.954,7.954,0,0,1,3.857,1.045c1.044.7,0,2.785-1.741,2.089",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38505",
    "data-name": "Path 38505",
    d: "M55.454,697.17a17.529,17.529,0,0,0,4.526,1.393c1.393,0,3.063-1.069,3.976-1.567,1.6-.871,2.42-.487,2.64.174.348,1.045-1.045,2.089-1.741,2.437A11.665,11.665,0,0,1,59.98,701c-2.089,0-4.178-1.393-5.919-1.393H51.624",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon9);
export default __webpack_public_path__ + "static/media/sidebar-icon-9.030c659e61156251db5f6c6604c003ee.svg";
export { ForwardRef as ReactComponent };